import { render, staticRenderFns } from "./AccountAdd.vue?vue&type=template&id=6c99a316&scoped=true&"
import script from "./AccountAdd.vue?vue&type=script&lang=js&"
export * from "./AccountAdd.vue?vue&type=script&lang=js&"
import style0 from "./AccountAdd.vue?vue&type=style&index=0&id=6c99a316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99a316",
  null
  
)

export default component.exports